function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F2FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0BB1D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M6.562,42.656C5.578,44.204,5,46.034,5,48c0,5.514,4.486,10,10,10  c0.301,0,0.607-0.016,0.923-0.047C17.42,61.001,20.571,63,24,63c4.962,0,9-4.038,9-9V43h7v-2h-7v-4h16v-2H33v-6h2v-2h-2v-4h12v-2H33  V10c0-4.962-4.038-9-9-9c-3.607,0-6.717,2.138-8.152,5.21l-0.047,0.01C10.701,7.255,7,11.789,7,17c0,1.26,0.214,2.493,0.638,3.676  C3.577,22.964,1,27.311,1,32C1,36.253,3.108,40.238,6.562,42.656z M9.333,22.051l0.896-0.421L9.817,20.73  C9.275,19.543,9,18.289,9,17c0-3.889,2.522-7.309,6.14-8.526C15.054,8.971,15,9.479,15,10c0,1.582,0.417,3.138,1.205,4.5  l1.731-1.001C17.324,12.441,17,11.23,17,10c0-3.86,3.14-7,7-7s7,3.14,7,7v44c0,3.86-3.14,7-7,7c-2.875,0-5.499-1.808-6.531-4.499  l-0.294-0.768l-0.81,0.14C15.875,55.959,15.428,56,15,56c-4.411,0-8-3.589-8-8s3.589-8,8-8v-2c-2.822,0-5.369,1.18-7.189,3.066  C4.834,39.026,3,35.636,3,32C3,27.765,5.486,23.86,9.333,22.051z M27,54h2c0,2.757-2.243,5-5,5v-2C25.654,57,27,55.654,27,54z   M15,52v2c-3.309,0-6-2.691-6-6h2C11,50.206,12.794,52,15,52z M53,53c0,1.654,1.346,3,3,3s3-1.346,3-3c0-1.302-0.839-2.402-2-2.816  V46c0-2.757-2.243-5-5-5H42v2h10c1.654,0,3,1.346,3,3v4.184C53.839,50.598,53,51.698,53,53z M56,54c-0.551,0-1-0.449-1-1  s0.449-1,1-1s1,0.449,1,1S56.551,54,56,54z M63,36c0-1.654-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H51v2h6.184  c0.414,1.161,1.514,2,2.816,2C61.654,39,63,37.654,63,36z M59,36c0-0.551,0.449-1,1-1s1,0.449,1,1s-0.449,1-1,1S59,36.551,59,36z   M57.184,27H37v2h20.184c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3s-1.346-3-3-3C58.698,25,57.598,25.839,57.184,27z M60,27  c0.551,0,1,0.449,1,1s-0.449,1-1,1s-1-0.449-1-1S59.449,27,60,27z M57,18v-4.184c1.161-0.414,2-1.514,2-2.816c0-1.654-1.346-3-3-3  s-3,1.346-3,3c0,1.302,0.839,2.402,2,2.816V18c0,1.654-1.346,3-3,3h-5v2h5C54.757,23,57,20.757,57,18z M56,10c0.551,0,1,0.449,1,1  s-0.449,1-1,1s-1-0.449-1-1S55.449,10,56,10z M11.879,33.95c-1.95-1.949-1.95-5.122,0-7.071c1.949-1.95,5.122-1.949,7.071,0  l-1.414,1.414c-1.17-1.17-3.073-1.171-4.243,0c-1.169,1.17-1.169,3.073,0,4.243L11.879,33.95z M21,10h-2c0-2.757,2.243-5,5-5  s5,2.243,5,5h-2c0-1.654-1.346-3-3-3S21,8.346,21,10z M23,29v-2c1.654,0,3-1.346,3-3s-1.346-3-3-3v-2c2.757,0,5,2.243,5,5  S25.757,29,23,29z M23,40v2c-1.654,0-3,1.346-3,3s1.346,3,3,3v2c-2.757,0-5-2.243-5-5S20.243,40,23,40z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.5b4f5011a54748aa7e0dd98679b7f573.svg";
export { ForwardRef as ReactComponent };